import { render } from "./CampaignListLayout.vue?vue&type=template&id=0d37be4a&scoped=true"
import script from "./CampaignListLayout.vue?vue&type=script&lang=js"
export * from "./CampaignListLayout.vue?vue&type=script&lang=js"

import "./CampaignListLayout.vue?vue&type=style&index=0&id=0d37be4a&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d37be4a"]])

export default __exports__